export default {"src":"/_next/static/media/course.1c3279d8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};